import { axiosInstance } from '@libs/axios/axios';
import { apiCall } from '@shared/entity';
import type { OnboardingProgress } from './queries';

export const onboardingApi = {
  getProgress: () => '/api/onboarding',
};

export const getOnboardingProgress = async (): Promise<OnboardingProgress> =>
  apiCall(
    async () => await axiosInstance.get(onboardingApi.getProgress()),
    'api.onboarding.progressError',
  );
